import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedMutation from './AuthorizedMutation';

const GQL = gql`
  mutation DeleteField($fieldId: String!) {
    archiveField(fieldId: $fieldId) {
      id
    }
  }
`;

export type DeleteFn = (fieldId: string) => void;

export type CompletedFn = (field: Field) => void;

interface Result {
  archiveField: Field;
}

interface Props {
  onCompleted: CompletedFn;
  children: (
    execute: DeleteFn,
    loading: boolean,
    done: boolean
  ) => React.ReactNode;
}

const DeleteFieldProvider: React.StatelessComponent<Props> = (props: Props) => {
  return (
    <AuthorizedMutation
      mutation={GQL}
      onCompleted={(data: Result) =>
        data ? props.onCompleted(data.archiveField) : null
      }
    >
      {(mutateFn, result) =>
        props.children(
          (fieldId: string) => mutateFn({ variables: { fieldId } }),
          result.loading,
          result.data && result.data.archiveField && result.data.archiveField.id
        )
      }
    </AuthorizedMutation>
  );
};

export default DeleteFieldProvider;



// WEBPACK FOOTER //
// ./src/providers/DeleteFieldProvider.tsx